import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { StatusBadge } from '../../../../../../../../components/status-badge';

export const PreferredDays = ({ preferredDays }: { preferredDays: string[] }) => {
  const { t } = useTranslation('schedule-request');
  const days = [
    { value: 'MONDAY', label: t('Mon') },
    { value: 'TUESDAY', label: t('Tue') },
    { value: 'WEDNESDAY', label: t('Wed') },
    { value: 'THURSDAY', label: t('Thu') },
    { value: 'FRIDAY', label: t('Fri') },
    { value: 'SATURDAY', label: t('Sat') },
    { value: 'SUNDAY', label: t('Sun') },
  ];
  const hasNoPreferredDays = !preferredDays.length;

  return (
    <div css={containerStyles}>
      {days.map(({ value, label }) => (
        <StatusBadge key={value} variant={hasNoPreferredDays || preferredDays.includes(value) ? 'green' : undefined}>
          {label}
        </StatusBadge>
      ))}
    </div>
  );
};

const containerStyles = css`
  display: flex;
  gap: 8px;
`;
